import React, { useState, useEffect, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Row } from "react-bootstrap";
import { MdDeleteOutline } from "react-icons/md";
import TextAreaWithList from "./textareaWithList";

const DynamicPrompt = ({
    selectedOptions,
    setSelectedOptions,
    generatedPrompt,
    setGeneratedPrompt,
    isShowGeneratedPrompt,
    setIsShowGeneratedPrompt,
    options,
    setOptions,
    handleChangeGeneratedPrompt,
    assistantPrompt,
    setAssistantPrompt,
    handleChangeAssistantPrompt,
    initialPrompt,
    setInitialPrompt,
    middlePrompt,
    endPrompt,
    setEndPrompt
}) => {
    let [newOption, setNewOption] = useState("");
    let [isOpen, setIsOpen] = useState(false);
    let [promptToDisplay, setPromptToDisplay] = useState('');
    const dropdownRef = useRef(null);
    let [headingsArr, setHeadingsArr] = useState([]);
    // let initialPrompt = "Compare the following '${Leads.Company}' data with '${Company}' generate a strategic business report.";
    // let middlePrompt = "Headings to include in the report:"
    // let prompt1 = 'Compare the following “Arvind Fashion”(Client company) data with “Digylax Private Limited" (Our company)and generate a strategic business report. Headings to include in the report: - Introduction ,Market Position ,Product Offerings .Customer Acquisition Strategy . Technology Stack ., Conclusion '
    const textareaRefs = useRef({});

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const handleSelect = (e, option) => {
        setSelectedOptions(prev =>
            prev.map(item =>
                item.key === option ? { ...item, is_include: e.target.checked } : item
            )
        );
    };

    const handleRemove = (option) => {
        setSelectedOptions(prev =>
            prev.map(item =>
                item.key === option ? { ...item, is_include: false } : item
            )
        );
    };

    const handleAddOption = () => {
        if (newOption.trim() && !options.includes(newOption)) {
            setOptions([...options, newOption]);
            const newItem = { key: newOption, is_include: true };
            setSelectedOptions([...selectedOptions, newItem]);
            setNewOption("");
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        Object.keys(textareaRefs.current).forEach(index => {
            autoResize(null, index);
        });
        if (selectedOptions.filter(item => item.is_include === true).length > 0) {
            // const headingsArr = selectedOptions
            //     .filter(item => item.is_include)
            //     .map(item => item.key)
            //     .join(', ');
            // console.log('heading arr:', selectedOptions)
            // setHeadingsArr(headingsArr)

            // setGeneratedPrompt(`${initialPrompt} \n\n${middlePrompt} \n${headingsArr} \n\n${endPrompt}`)

            // setGeneratedPrompt(
            //     initialPrompt +
            //     selectedOptions
            //         .filter((item) => item.is_include === true)
            //         .map((item) => item.key)
            //         .join(', ') +
            //     endString
            // )
            // setGeneratedPrompt(prompt)
        } else {
            setIsShowGeneratedPrompt(false)
            setGeneratedPrompt('')
        }
    }, [selectedOptions, setSelectedOptions])

    const handleShowPrompt = () => {
        if (selectedOptions.filter(item => item.is_include === true).length > 0) {
            setIsShowGeneratedPrompt(true)
            handleChangeGeneratedPrompt(initialPrompt + ' ' + endPrompt)
        }
    }

    const handleDelete = (i) => {
        setOptions(prev => prev.filter((_, index) => index !== i));
        setSelectedOptions(prev => prev.filter((_, index) => index !== i));
    };

    // useEffect(() => {
    //     const headingsArr = selectedOptions
    //         .filter(item => item.is_include)
    //         .map(item => item.key)
    //         .join(', ');
    //     setPromptToDisplay(`${prompt} Headings to include in the report: \n\n${headingsArr}`)
    // }, [generatedPrompt, selectedOptions])

    const handleChangeInitialPrompt = (e) => {
        setInitialPrompt(e.target.value)
    }
    const handleChangeEndPrompt = (e) => {
        setEndPrompt(e.target.value)
    }

    // useEffect(() => {
    //     handleChangeGeneratedPrompt(initialPrompt + ' ' + endPrompt)
    // }, [initialPrompt, endPrompt])

    const autoResize = (e, index) => {
        const textarea = textareaRefs.current[index];
        if (textarea) {
            textarea.style.height = "auto";
            textarea.style.height = `${textarea.scrollHeight}px`;
        }
    };


    return (
        <>
            {/* <TextAreaWithList /> */}
            <Row className="justify-content-md-center">
                <div className="col col-md-8 col-lg-6" ref={dropdownRef}>
                    <Row className="mt-3">
                        <div className="col-12">

                            <div className="dropdown">
                                <div
                                    className="btn btn-link border dropdown-toggle with-arrow justify-content-start text-dark text-decoration-none"
                                    onClick={toggleDropdown} type="button"
                                    id="triggerId"
                                    data-bs-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                >
                                    <span>Select or Add Keywords</span>
                                </div>
                                {isOpen && (
                                    <div className="dropdown-menu w-100 show p-2 pb-3" aria-labelledby="triggerId">
                                        <div className="overflow-y-auto mb-4" style={{ maxHeight: "200px" }}>
                                            {options.map((option, index) => (
                                                <div key={option} className="form-check cbox-keyword">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`keyword${index}`}
                                                        checked={selectedOptions.some(item => item.key === option && item.is_include === true)}
                                                        onChange={(e) => handleSelect(e, option)}
                                                    />
                                                    <label className="form-check-label ms-2" htmlFor={`keyword${index}`}>{option}</label>
                                                    <button
                                                        onClick={() => handleDelete(index)}
                                                        className="delete-keyword"
                                                        title="Delete"
                                                    >
                                                        <MdDeleteOutline />
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                        <div className="input-group mt-2 position-absolute w-100 start-0 bottom-0">
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={newOption}
                                                onChange={(e) => setNewOption(e.target.value)}
                                                placeholder="Add new keyword"
                                            />
                                            <button className="btn btn-primary btn-blue" onClick={handleAddOption}>Add</button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="mt-2 sel-keyword">
                                <p className="fw-semibold pt-2 px-2">Selected Keywords</p>
                                <div className="d-flex flex-wrap px-2 pb-2">
                                    {selectedOptions.map((option) => option.is_include === true && (
                                        <div className="select__multi-value css-1p3m7a8-multiValue">
                                            <div className="select__multi-value__label css-9jq23d">{option.key}</div>
                                            <div role="button" className="select__multi-value__remove css-v7duua" aria-label="Remove Blue" onClick={() => handleRemove(option.key)}>
                                                <svg height="14" width="14" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-8mmkcg">
                                                    <path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z">
                                                    </path>
                                                </svg>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="col-12">
                            <button type="button" className="mt-2 btn btn-primary btn-blue float-end"
                                disabled={!selectedOptions.length} onClick={handleShowPrompt}>
                                <span>Generate Prompt</span>
                            </button>
                        </div>
                        {isShowGeneratedPrompt &&
                            <>
                                <div className="col-12">
                                    <div className="mt-2">
                                        <p className="fw-semibold">Research Assistant</p>
                                        <div className="d-flex flex-wrap mt-2">
                                            <textarea className="form-control border-0-"
                                                // value={prompt}
                                                value={assistantPrompt}
                                                rows={5}
                                                onChange={(e) => {
                                                    handleChangeAssistantPrompt(e);
                                                    autoResize(e, 2);
                                                }}
                                                maxLength={400}
                                                ref={(el) => (textareaRefs.current[2] = el)}
                                                style={{ overflow: "hidden", resize: "none" }}
                                            ></textarea>
                                        </div>
                                    </div>
                                    <span className="fw-semibold prompt-note">Note: The prompt length should be 400 characters or fewer</span>
                                </div>
                                <div className="col-12">
                                    <div className="mt-3">
                                        <p className="fw-semibold">AI</p>

                                        <div
                                        // className="max-w-4xl mx-auto p-6 bg-white rounded-2xl shadow-lg grid grid-cols-3 gap-4"
                                        >
                                            {/* Left Textarea */}
                                            <textarea
                                                className="ai-prompt form-control border-0-"
                                                value={initialPrompt}
                                                rows={5}
                                                onChange={(e) => {
                                                    handleChangeInitialPrompt(e);
                                                    autoResize(e, 0);
                                                }}
                                                ref={(el) => (textareaRefs.current[0] = el)}
                                                style={{ overflow: "hidden", resize: "none" }}
                                            />

                                            {/* List */}
                                            <div className="mt-3">{middlePrompt}</div>
                                            <ul className="border-0 px-4 py-2 overflow-y-auto bg-gray-50" style={{ listStyleType: 'decimal' }}>
                                                {selectedOptions.map((item, index) => item?.is_include === true && (
                                                    <li key={index} className="p-2">
                                                        {item?.key}
                                                    </li>
                                                ))}
                                            </ul>

                                            {/* Right Textarea */}
                                            <textarea
                                                className="ai-prompt form-control border-0-"
                                                value={endPrompt}
                                                rows={5}
                                                onChange={(e) => {
                                                    handleChangeEndPrompt(e);
                                                    autoResize(e, 1); // Auto-resize for end prompt
                                                }}
                                                ref={(el) => (textareaRefs.current[1] = el)}
                                                style={{ overflow: "hidden", resize: "none" }}
                                            />
                                        </div>
                                        {/* <div className="d-flex flex-wrap mt-2"> 
                                            <textarea className="form-control border-0-"
                                                // value={prompt}
                                                value={generatedPrompt}
                                                rows={5}
                                                onChange={(e) => handleChangeGeneratedPrompt(e)}
                                            // maxLength={400}
                                            ></textarea>
                                        </div>*/}
                                    </div>
                                    {/* <span className="fw-semibold prompt-note">Note: The prompt length should be 400 characters or fewer</span> */}
                                </div>
                            </>
                        }
                    </Row>
                </div>
            </Row>
        </>
    );
};

export default DynamicPrompt;